module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "awards"
  }, [_c('div', {
    staticClass: "awards__container"
  }, [_c('div', {
    ref: "background",
    staticClass: "awards__background"
  }), _c('div', {
    staticClass: "awards__wrapper content"
  }, [_c('div', {
    ref: "title",
    staticClass: "content__header"
  }, [_vm._v(_vm._s(_vm.$content.title))]), _c('div', {
    staticClass: "content__main list"
  }, _vm._l((_vm.$content.items), function(award) {
    return _c('div', {
      ref: "items",
      refInFor: true,
      staticClass: "list__item item"
    }, [_c('div', {
      staticClass: "item-hgroup"
    }, [_c('div', {
      staticClass: "item-hgroup__heading"
    }, [_vm._v(_vm._s(award.title))]), _c('div', {
      staticClass: "item-hgroup__label"
    }, [_vm._v(_vm._s(_vm._f("getYear")(award.date)))])]), _c('div', {
      staticClass: "item-content"
    }, [_c('p', {
      staticClass: "item-content__text"
    }, [_vm._v(_vm._s(award.description))])]), _c('div', {
      staticClass: "item-actions"
    }, [_c('base-button', {
      staticClass: "item-actions__button",
      attrs: {
        "label": _vm.$t('launch-site'),
        "url": award.url,
        "white": true
      }
    })], 1)])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a2d0226","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/awards.vue
// module id = 472
// module chunks = 0